const config = {
  backend_films_url: 'http://zhovten.mx.local/ua/api/1/cinema/0000000026/films',
  client_films_url: '/films',
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js